// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.logos.RentalManagerUserPropertyLogoWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyLogoUploadRequestWebDto, UserPropertyLogoUploadResponseWebDto } from '../..';

interface DeleteParams {
  listingAlias: ListingAlias;
}
interface UploadParams {
  listingAlias: ListingAlias;
  sourceUrl?: string;
}

export const RentalManagerUserPropertyLogoWebApiHandler_delete_Path = '/api/web/v1/users/properties/logos/delete';

/**
 * Delete a property logo
 * @deprecated
 */
export const RentalManagerUserPropertyLogoWebApiHandler_delete = (getParams: DeleteParams, client = getClient()) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyLogoWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyLogoWebApiHandler_upload_Path = '/api/web/v1/users/properties/logos/upload';

/**
 * Upload a property logo
 */
export const RentalManagerUserPropertyLogoWebApiHandler_upload = (
  getParams: UploadParams,
  postData: UserPropertyLogoUploadRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<UploadParams, UserPropertyLogoUploadRequestWebDto, UserPropertyLogoUploadResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyLogoWebApiHandler_upload_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};
